<template>
  <div style="width: 100%;">
    <!-- banner -->
    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_banner_fir.jpg"
      style="width: 100vw;height: 20vw;margin-top:2px;"
    />

    <div v-if="ISphone" class="fx-column fx-row-center">
      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_short_media_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_value_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_cooperate_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_show_ph.png"
        style="width: 100vw;"
      />
    </div>
    <div v-else>
      <div class="choosesection fx-column fx-row-center">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw; ">愉悦推能为您提供什么</div>

        <div class="blueline"></div>

        <div
          :class="ISphone ? smallh3label : bigh3label"
          style="margin-top: 3vw; color: #515978; width:90%;"
        >为企业洞悉市场机遇，通过整合营销提高品牌声量，打造可持续推广的品牌传播方案</div>

        <div
          class="fx-row fx-row-center fx-row-space-between"
          style="width:80vw; margin-top: 4vw; margin-bottom: 1vw;"
        >
          <!-- 55 -->
          <div
            class="onesection fx-column fx-row-center"
            v-for="(item, index) in onearray"
            v-bind:key="index"
            v-bind:style="ISphone ? { height: 75 + 'vw' } : { height: 29 + 'vw' }"
          >
            <div
              class="he_border1"
              style="width: 25vw;height: 14.6vw; background:#fe7253;  border-radius: 10px;  border: none; "
            >
              <img class="he_border1_img" :src="item.iconurl" />
              <div class="he_border1_caption"></div>
            </div>

            <div
              :class="ISphone ? smallh2label : bigh3label"
              style="margin-top: 3.8vw; width: 18.2vw; color:#515978;"
            >{{ item.titlestr }}</div>
          </div>
        </div>
      </div>

      <!--  媒体属性与价值-->
      <div class="plan fx-column fx-row-center">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;  ">媒体属性与价值</div>

        <div class="blueline" style=" margin-bottom: 4vw; "></div>

        <div class="plantable fx-row fx-row-center fx-row-space-between">
          <div
            class="plancell hvr_grow_shadow fx-column fx-row-center"
            v-for="(item, index) in twoarray"
            v-bind:key="index"
            v-bind:style="ISphone ? { height: 94 + 'vw' } : { height: 29 + 'vw' }"
          >
            <img class="plancell_icon" :src="item.iconurl" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              class="plancell_name"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh3label : 'pxlabel_14'"
              class="plancell_des"
            >{{ item.desstr }}</div>
          </div>
        </div>
      </div>

      <!-- 广告合作形式 -->

      <!--   业务  bussiness -->
      <div class="bussiness fx-column fx-row-center" style="background:white;">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">广告合作形式</div>
        <div class="blueline"></div>

        <div
          class="fx-row fx-row-top fx-row-space-between"
          style="width: 75vw; margin-top: 3vw; margin-bottom: 5vw;"
        >
          <div
            class="fx-column fx-row-center"
            v-for="(item, index) in threearray"
            v-bind:key="index"
          >
            <img class="bussiness_icon hvr_grow_shadow" :src="item.iconurl" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_28'"
              class="bussiness_title"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_14'"
              class="bussiness_des"
            >{{ item.desstr }}</div>
          </div>
        </div>

        <!--      21vw   24.6vw   -->
      </div>

      <!-- 大图 -->

      <img
        src="http://pic.midongtech.xyz/yytgw/assets/img_spread_bg_content_new.jpg"
        style="width: 100vw;margin-top:2px;"
      />
    </div>

    <!-- 联系我们 -->
    <contactusview />
  </div>
</template>

<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "newmediapromotion",
  components: {
    contactusview
    // companybtm,
    //   partner
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      bigh4label: "bigh4label",
      onearray: [
        {
          titlestr:
            "梳理行业现状，深度挖掘品牌定位树立品牌形象，打造有企业特色的品牌IP",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_service_fir.png"
        },
        {
          titlestr:
            "把握新闻热点，制造热门话题，增加品牌公众曝光，引导用户参与线上线下营销活动",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_service_sec.png"
        },
        {
          titlestr:
            "分析受众媒体使用规律，制定有针对性的媒体投放计划并执行落地，达成传播效果",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_service_thir.png"
        }
      ],
      twoarray: [
        {
          titlestr: "微博话题",
          desstr:
            "把握新闻热点，制造热门话题，大V转发引导用户参与讨论、产出内容、话题上榜，扩大话题传播度，结合后续线上线下活动，最终提升营销效果",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_value_fir.png"
        },
        {
          titlestr: "微信公众号",
          desstr:
            "寻找针对性的公众号媒体，在合适的时间投放合适文风的文章，增加品牌曝光，聚拢更多人气，优化传播效果转化",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_value_sec.png"
        },
        {
          titlestr: "短视频",
          desstr:
            "立足抖音、快手、小红书等，以UGC形式贴近受众，深入挖掘用户痛点，顺势结合品牌定位树立品牌形象，通过有趣有料的内容提升转发量，提高品牌知名度和用户好感度",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_value_thir.png"
        }
      ],
      threearray: [
        {
          titlestr: "撰写创意话题文案",
          desstr: "优秀有趣的文案能够迅速传播，打开话题讨论热度",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_fir.png"
        },
        {
          titlestr: "制定媒体投放方案",
          desstr: "有针对性的媒体投放计划能够直达目标客户，增强传播效果",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_sec.png"
        },
        {
          titlestr: "线上线下营销策划",
          desstr: "紧凑的后续活动推广让品牌持续曝光，获取有效流量，快速变现",
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_spread_img_ad_thir.png"
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.plan {
  background: #f3f4f6;
  width: 100vw;
}

.plantable {
  width: 80vw;
  margin-bottom: 4vw;
}
.plancell {
  width: 25vw;
  // height: 25vw;
  background: #ffffff;
  box-shadow: 0 21px 43px 0 rgba(22, 33, 75, 0.15);
  border-radius: 4px;
  padding-top: 1vw;
  padding-bottom: 1vw;
}
.plancell_icon {
  width: 9.43vw;
  height: 9.43vw;
  margin-top: 3vw;
}
.plancell_name {
  margin-top: 1.2vw;
  text-align: center;
  font-weight: middle;
  color: #16214b;
}

.plancell_des {
  margin-top: 1.4vw;
  margin-bottom: 4vw;
  width: 18.2vw;
  text-align: center;
  color: #515978;
}

//

.choosesection {
  width: 100vw;
  // height: 50vw;
  // background: white;

  // border: none;
}
// .onesection {
//   width: 25vw;
//   height: 25vw;
//   background: #ffffff;
//   border-radius: 10px;
//   // margin-bottom: 10vw;
//   padding-bottom: 10vw;
// }
</style>
